import State from 'webutils/services/state'

export default [
    new State("DIF", "Distrito Federal"),
    new State("AGS", "Aguascalientes"),
    new State("BCN", "Baja California"),
    new State("BCS", "Baja California Sur"),
    new State("CAM", "Campeche"),
    new State("CHP", "Chiapas"),
    new State("CHI", "Chihuahua"),
    new State("COA", "Coahuila"),
    new State("COL", "Colima"),
    new State("DUR", "Durango"),
    new State("GTO", "Guanajuato"),
    new State("GRO", "Guerrero"),
    new State("HGO", "Hidalgo"),
    new State("JAL", "Jalisco"),
    new State("MEX", "México"),
    new State("MIC", "Michoacán"),
    new State("MOR", "Morelos"),
    new State("NAY", "Nayarit"),
    new State("NLE", "Nuevo León"),
    new State("OAX", "Oaxaca"),
    new State("PUE", "Puebla"),
    new State("QRO", "Querétaro"),
    new State("ROO", "Quintana Roo"),
    new State("SLP", "San Luis Potosí"),
    new State("SIN", "Sinaloa"),
    new State("SON", "Sonora"),
    new State("TAB", "Tabasco"),
    new State("TAM", "Tamaulipas"),
    new State("TLX", "Tlaxcala"),
    new State("VER", "Veracruz"),
    new State("YUC", "Yucatán"),
    new State("ZAC", "Zacatecas")
];